export default {"src":"/_next/static/media/search.e1f67b73.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};